/**
 * SEO meta tags – jediný súbor na úpravu titulkov, popisov a obrázka pre zdieľanie.
 * Zmeny tu sa prejavia na všetkých stránkach (okrem dynamických event/archive-item, ktoré berú dáta z API).
 *
 * Pre predvolený OG obrázok použite absolútnu URL (odporúčané 1200×630 px pre sociálne siete).
 */

const siteUrl = process.env.REACT_APP_SITE_URL || '';

export const seo = {
  /** Predvolené hodnoty (fallback, používa sa aj v index.html) */
  defaults: {
    title: 'Skiland Stará Myjava – lyžiarske stredisko',
    description:
      'Lyžiarske stredisko Skiland Stará Myjava. Otváracie hodiny, cenník, podujatia, inštruktori a živý prehľad z kamier.',
    image: siteUrl ? `${siteUrl}/logo.png` : '',
  },

  /** Meta pre jednotlivé stránky – upravte podľa potreby */
  pages: {
    home: {
      title: 'Skiland Stará Myjava – lyžiarske stredisko',
      description:
        'Lyžiarske stredisko v Starej Myjave. Informácie, cenník, podujatia, inštruktori a kontakt. Pozrite si živý záber z kamier.',
    },
    events: {
      title: 'Podujatia – Skiland Stará Myjava',
      description:
        'Nadchádzajúce podujatia a akcie v Skiland Stará Myjava. Program, fotky a termíny v lyžiarskom stredisku.',
    },
    archive: {
      title: 'Archív podujatí – Skiland Stará Myjava',
      description:
        'Archív uskutočnených podujatí Skiland Stará Myjava. Fotky a zápisky z akcií v lyžiarskom stredisku.',
    },
    cameras: {
      title: 'Živý záber z kamier – Skiland Stará Myjava',
      description:
        'Aktuálny pohľad z kamier na lyžiarske stredisko Skiland Stará Myjava. Sledujte počasie a stav tratí v reálnom čase.',
    },
    login: {
      title: 'Prihlásenie – Skiland Stará Myjava',
      description: '',
    },
    dashboard: {
      title: 'Administrácia',
      noIndex: true,
    },
  },
};

export default seo;
